import * as yup from "yup";

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for name")
    .label("Registered Name"),
  pocName: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for name")
    .label("PoC Name"),
  pocContact: yup
    .string()
    .required()
    .matches(/^[0-9]+$/, "Please enter valid contact number")
    .min(10)
    .max(10)
    .label("PoC Phone"),
  operatingStates: yup.array().min(1).required().label("Operating State"),
  address: yup.object().shape({
    addressLine1: yup
      .string()
      .required()
      .matches(/^(?!\s+$).+/, "Please provide valid values in address field")
      .label("Address Line 1"),
    addressLine2: yup.string().label("Address Line 2"),
    country: yup.string().required().label("Country"),
    state: yup.string().required().label("State"),
    city: yup.string().required().label("City"),
    pincode: yup
      .string()
      .required()
      .matches(/^[0-9]+$/, "Please enter valid pincode")
      .min(6)
      .max(6)
      .label("Pincode"),
  }),
  remarks: yup.string().label("Remarks"),
  contract: yup.mixed().label("Contract"),
});

export default schema;
